import React, { useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AdminNavbar from "../../components/admin/AdminNavbar";
import styles from "./AdminLayout.module.css";

function getPageTitle(pathname) {
  if (pathname === "/admin") return "Dashboard Overview";
  if (pathname.startsWith("/admin/users")) return "Manage Users";
  if (pathname.startsWith("/admin/profiles")) return "Manage Profiles";
  return "Admin Panel";
}

export default function AdminLayout() {
  const location = useLocation();

  const pageTitle = useMemo(
    () => getPageTitle(location.pathname),
    [location.pathname]
  );

  return (
    <div className={styles.AdminShell_mx71}>
      <AdminNavbar pageTitle={pageTitle} />

      <div className={styles.AdminContentWrap_mx71}>
        {/* <div className={styles.AdminPageHeader_mx71}>
          <div>
            <h1 className={styles.AdminPageTitle_mx71}>{pageTitle}</h1>
            <p className={styles.AdminPageSubtitle_mx71}>
              Monitor, manage and review DulhaSarkari platform data.
            </p>
          </div>
        </div> */}

        <main className={styles.AdminMain_mx71}>
          <div className={styles.AdminCard_mx71}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}